import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import AdminModal from '../AdminModal';
import TenderData from './TenderData';

const ModalWrapper = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-x: auto;
`;

const TenderAdminViewModal = ({
  onClose,
  selectedIds = [],
  type,
  data,
  selectedInfo
}) => {
  const showDoneModalNode = React.useRef();

  const onCloseModal = () => {
    onClose();
  };

  const OBJECTS = data.filter(
    (i) =>
      !!selectedIds.find((si) => {
        return si === i.id;
      })
  );
  return (
    <AdminModal
      ref={showDoneModalNode}
      onClose={onCloseModal}
      label={'Tender Viewer'}
      name={'Tender Viewer'}
      Component={() => (
        <ModalWrapper>
          {OBJECTS.map((OneBinder, key) => (
            <TenderData
              key={key}
              tender={OneBinder}
              organizationId={OneBinder.organizationId}
              type={type}
            />
          ))}
        </ModalWrapper>
      )}
    />
  );
};

export default TenderAdminViewModal;
